export enum SymptomArticleCodes {
  ARTICLE = 'symptom_article_detail',
  ARTICLE_RELATED_TOPICS = 'symptom_related_topic_detail',
}
